export default __webpack_public_path__ + "static/media/logo-c.d0f15e76.webp";